import { forwardRef } from 'react';
import { type ChildAndClassNameProps } from '../types';
import { cn } from '../utils';

export const Grid = forwardRef<HTMLDivElement, ChildAndClassNameProps>(
  ({ children, className, ...props }, forwardedRef) => {
    return (
      <div
        ref={forwardedRef}
        className={cn(
          'mx-auto box-border w-full max-w-screen-xl px-16 md:px-32',
          className,
        )}
        {...props}
      >
        {children}
      </div>
    );
  },
);

Grid.displayName = 'Grid';
